// extracted by mini-css-extract-plugin
export default {"contractBanner":"BannerErrorEmployeds_contractBanner__Uvfws","danger":"BannerErrorEmployeds_danger__ModiV"};